import { t, Trans } from '@lingui/macro';
import { useState } from 'react';
import {
  MenuItem,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Button,
  Dialog,
} from '@mui/material';
import { TableEmpty } from 'components';
import { useSearch } from 'hooks';
import { useQuery } from 'react-query';
import { enterpriseSetupService } from 'services';
import { EnterpriseType } from 'types/Enterprise';
import { HRNoticePopup } from 'views/HR/popups';
import { DateTime } from 'luxon';

const HRManagementEligibleEmployee = ({ enterprise }: { enterprise?: EnterpriseType }) => {
  const [dataSearch, onSearchChange] = useSearch();
  const { data } = useQuery(
    ['enterpriseSetupService.fetchEmployees', { id: enterprise?.id!, workingType: 'ACTIVE', ...dataSearch }],
    () => enterpriseSetupService.fetchEmployees({ id: enterprise?.id!, workingType: 'ACTIVE', ...dataSearch }),
    { keepPreviousData: true },
  );

  const [openNotice, setOpenNotice] = useState(false);
  const [noticeChoiceKey, setNoticeChoiceKey] = useState('');

  const { data: employees = [], paginate } = data ?? {};
  return (
    <div>
      <div className='flex items-end justify-between'>
        <Typography variant='h4'>
          <Trans>Eligible Employee Notice</Trans>
        </Typography>
        <div className='space-x-3'>
          <TextField select defaultValue={1}>
            <MenuItem value={1}>
              <Trans>Employee Name</Trans>
            </MenuItem>
            <MenuItem value={2}>
              <Trans>ID No.</Trans>
            </MenuItem>
            <MenuItem value={3}>
              <Trans>Type</Trans>
            </MenuItem>
            <MenuItem value={4}>
              <Trans>Level</Trans>
            </MenuItem>
          </TextField>
          <TextField placeholder={t`Search...`} />
        </div>
      </div>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <Trans>Notice Day</Trans>
              </TableCell>
              <TableCell>
                <Trans>Employee Name</Trans>
              </TableCell>
              <TableCell>
                <Trans>ID No.</Trans>
              </TableCell>
              <TableCell>
                <Trans>Staff ID</Trans>
              </TableCell>
              <TableCell>
                <Trans>Account Number</Trans>
              </TableCell>
              <TableCell>
                <Trans>Bank Name</Trans>
              </TableCell>
              <TableCell>
                <Trans>Notice</Trans>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {employees.map((item) => (
              <TableRow key={item.employeeId}>
                <TableCell>
                  {item.conditionNoticeDate ? DateTime.fromISO(item.conditionNoticeDate).toFormat('dd/MM/yyyy') : ''}
                </TableCell>
                <TableCell>{item.employee.name}</TableCell>
                <TableCell>{item.employee.id}</TableCell>
                <TableCell>{item.employee.employeeCode}</TableCell>
                <TableCell>{item.employee.bankAccountNumber}</TableCell>
                <TableCell>{item.employee.bankName}</TableCell>
                <TableCell align='center'>
                  <Button
                    size='small'
                    color='info'
                    onClick={() => {
                      setOpenNotice(true);
                      setNoticeChoiceKey(item.conditionNoticeKey);
                    }}
                  >
                    <Trans>View</Trans>
                  </Button>
                </TableCell>
              </TableRow>
            ))}
            <TableEmpty data={employees} />
          </TableBody>
        </Table>
      </TableContainer>

      <div className='flex justify-center'>
        <Pagination
          page={paginate?.page ?? 1}
          count={paginate?.totalPage}
          onChange={(event, value) => {
            onSearchChange({ page: value });
          }}
        />
      </div>

      <Dialog fullWidth maxWidth='lg' open={openNotice} onClose={() => setOpenNotice(false)}>
        <HRNoticePopup conditionNoticeKey={noticeChoiceKey} onClose={() => setOpenNotice(false)} />
      </Dialog>
    </div>
  );
};

export default HRManagementEligibleEmployee;
